"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  highlightCodeBlocks: true,
  prepareSpoilersAndQuotes: true,
  logError: true,
  addGlobalPublishers: true,
  resolveScriptElement: true
};
Object.defineProperty(exports, "addGlobalPublishers", {
  enumerable: true,
  get: function get() {
    return _globalPublishers.addGlobalPublishers;
  }
});
Object.defineProperty(exports, "highlightCodeBlocks", {
  enumerable: true,
  get: function get() {
    return _codeHighlighting.highlightCodeBlocks;
  }
});
Object.defineProperty(exports, "logError", {
  enumerable: true,
  get: function get() {
    return _errorLogging.logError;
  }
});
Object.defineProperty(exports, "prepareSpoilersAndQuotes", {
  enumerable: true,
  get: function get() {
    return _contentPreparation.prepareSpoilersAndQuotes;
  }
});
Object.defineProperty(exports, "resolveScriptElement", {
  enumerable: true,
  get: function get() {
    return _scriptElement.resolveScriptElement;
  }
});

var _codeHighlighting = require("./codeHighlighting");

var _contentPreparation = require("./contentPreparation");

var _errorLogging = require("./errorLogging");

var _globalPublishers = require("./globalPublishers");

var _scriptElement = require("./scriptElement");

var _componentInitialization = require("./componentInitialization");

Object.keys(_componentInitialization).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _componentInitialization[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _componentInitialization[key];
    }
  });
});

var _initializeUrlNavigation = require("./initializeUrlNavigation");

Object.keys(_initializeUrlNavigation).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _initializeUrlNavigation[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _initializeUrlNavigation[key];
    }
  });
});